import { createSlice } from '@reduxjs/toolkit';
import { REDUCER_KEY } from './products.consts';
import { ProductParams } from './products.types';

const slice = createSlice({
  name: REDUCER_KEY,
  initialState: {
    selected: [] as ProductParams[],
    errorIds: [] as number[],
  },
  reducers: {
    addSelectedProduct: (state: { selected: ProductParams[] }, action) => {
      if (!state.selected.find(p => p.id === action.payload.id)) {
        state.selected.push(action.payload);
      }
    },
    removeSelectedProduct: (state: { selected: ProductParams[] }, action) => {
      state.selected = state.selected.filter(({ id }) => id !== action.payload);
    },
    clearSelectedProducts: (state: { selected: ProductParams[] }) => {
      state.selected = [];
    },
    setErrorIds: (state: { errorIds: number[] }, action) => {
      state.errorIds = action.payload;
    },
    removeErrorId: (state: { errorIds: number[] }, action) => {
      state.errorIds = state.errorIds.filter(id => id !== action.payload);
    },
    clearErrorIds: (state: { errorIds: number[] }) => {
      state.errorIds = [];
    },
  },
});

export const {
  addSelectedProduct,
  removeSelectedProduct,
  clearSelectedProducts,
  setErrorIds,
  removeErrorId,
  clearErrorIds,
} = slice.actions;
export const { reducer } = slice;
